'use strict';

const setAvailableBusinessProcesses = (state, businessProcesses = []) => {
  state.availableBusinessProcesses = businessProcesses;
};

const setSupervisedBusinessProcesses = (state, businessProcesses = []) => {
  state.supervisedBusinessProcesses = businessProcesses;
};

const setBusinessProcessHealthConfigurationTemplates = (state, healthConfigurationTemplates = []) => {
  state.businessProcessHealthConfigurationTemplates = healthConfigurationTemplates;
};

const addBusinessProcessHealthConfiguration = (state, healthConfiguration) => {
  state.businessProcessHealthConfigurations.push(healthConfiguration);
};

const addBusinessProcessHealthThreshold = (state, healthThreshold) => {
  state.businessProcessHealthThresholds.push(healthThreshold);
};

const addBusinessProcessHealthThresholds = (state, healthThresholds) => {
  state.businessProcessHealthThresholds = state.businessProcessHealthThresholds.concat(healthThresholds);
};

const updateBusinessProcessHealthThresholds = (state, data) => {
  const thresholdsIndex = state.businessProcessHealthThresholds.findIndex(
    healthThreshold => healthThreshold.businessProcessId === data.businessProcessId && healthThreshold._id === data._id
  );
  if (thresholdsIndex === -1) {
    return;
  }
  state.businessProcessHealthThresholds.splice(thresholdsIndex, 1, data);
};

const deleteBusinessProcessHealthThreshold = (state, bpHealthThresholdId) => {
  state.businessProcessHealthThresholds = state.businessProcessHealthThresholds.filter(
    healthThreshold => healthThreshold._id !== bpHealthThresholdId
  );
};

const disableCurrentActiveHealtThresholds = (state, bpIds) => {
  state.businessProcessHealthThresholds.forEach(bpHealthThreshold => {
    if (bpIds.includes(bpHealthThreshold.businessProcessId)) {
      bpHealthThreshold.active = false;
    }
  });
};

export default {
  setAvailableBusinessProcesses,
  setSupervisedBusinessProcesses,
  setBusinessProcessHealthConfigurationTemplates,
  addBusinessProcessHealthConfiguration,
  addBusinessProcessHealthThreshold,
  addBusinessProcessHealthThresholds,
  updateBusinessProcessHealthThresholds,
  deleteBusinessProcessHealthThreshold,
  disableCurrentActiveHealtThresholds
};
